var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16699 5.66666C8.16699 5.20666 8.54033 4.83332 9.00033 4.83332C9.46033 4.83332 9.83366 5.20666 9.83366 5.66666C9.83366 6.12666 9.46033 6.49999 9.00033 6.49999C8.54033 6.49999 8.16699 6.12666 8.16699 5.66666ZM8.16699 8.16666C8.16699 7.70666 8.54033 7.33332 9.00033 7.33332C9.46033 7.33332 9.83366 7.70666 9.83366 8.16666V12.3333C9.83366 12.7933 9.46033 13.1667 9.00033 13.1667C8.54033 13.1667 8.16699 12.7933 8.16699 12.3333V8.16666ZM9.00033 15.6667C5.32449 15.6667 2.33366 12.6758 2.33366 8.99999C2.33366 5.32416 5.32449 2.33332 9.00033 2.33332C12.6762 2.33332 15.667 5.32416 15.667 8.99999C15.667 12.6758 12.6762 15.6667 9.00033 15.6667ZM9.00033 0.666656C4.39783 0.666656 0.666992 4.39749 0.666992 8.99999C0.666992 13.6025 4.39783 17.3333 9.00033 17.3333C13.602 17.3333 17.3337 13.6025 17.3337 8.99999C17.3337 4.39749 13.602 0.666656 9.00033 0.666656Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlackIcon);
export default __webpack_public_path__ + "static/media/InfoBlackIcon.f21f3ed867215f27783ff43a8895879e.svg";
export { ForwardRef as ReactComponent };